import axios from 'api';
import { showMessage } from 'app/store/actions/fuse';
import { getCurrentApiUrl } from 'app/helpers';
import i18n from 'i18next';

require('dotenv').config();

export const GET_DASHBOARD_MESSAGES = '[CONSOLE] GET MESSAGES';
export const GET_DASHBOARD_MESSAGES_UNIT = '[CONSOLE] GET MESSAGES UNIT';
export const GET_DASHBOARD_NOTIFICATIONS = '[CONSOLE] GET NOTIFICATIONS';
export const SET_MESSAGES_DELETE_ID = '[CONSOLE] SET_MESSAGES_DELETE_ID';
export const GET_GROUPS = '[CONSOLE] GET GROUPS';

export function getGroups() {
  const request = axios.get(`${getCurrentApiUrl()}/groups`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_GROUPS,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getDashboardMessages() {
  const request = axios.get(`${getCurrentApiUrl()}/dashboard/messages`, {});
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DASHBOARD_MESSAGES,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getDashboardMessagesUnit(id) {
  const request = axios.get(
    `${getCurrentApiUrl()}/dashboard/messages/${id}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DASHBOARD_MESSAGES_UNIT,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getDashboardMessagesUserId(user_id) {
  const request = axios.get(
    `${getCurrentApiUrl()}/dashboard/notifications/${user_id}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_DASHBOARD_NOTIFICATIONS,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function setMessagesDeleteId(delete_id) {
  return {
    type: SET_MESSAGES_DELETE_ID,
    delete_id
  };
}

export function deleteMessage(id, navigate) {
  const request = axios.delete(
    `${getCurrentApiUrl()}/dashboard/messages/${id}`,
    {}
  );
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.delation.deletion_success') })
        );
        dispatch(getDashboardMessages());
        navigate('/dashboard/notifications');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function updateMessages(data, id) {
  const request = axios.put(
    `${getCurrentApiUrl()}/dashboard/messages/${id}`,
    data
  );
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.modify.modify_success') })
        );
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}

export function createMessage(data, navigate) {
  const request = axios.post(`${getCurrentApiUrl()}/dashboard/messages`, data);
  return dispatch =>
    request
      .then(response => {
        dispatch(
          showMessage({ message: i18n.t('action.creation.creation_success') })
        );
        navigate('/dashboard/notifications');
      })
      .catch(err => {
        dispatch(showMessage({ message: i18n.t('action.error') }));
      });
}
